import { useEffect, useRef } from 'react'

let lockCount = 0
let originalOverflow = ''
let originalPaddingRight = ''

export function useBodyScrollLock(active: boolean) {
  const lockedByThis = useRef(false)

  useEffect(() => {
    if (active && !lockedByThis.current) {
      lockedByThis.current = true
      lockCount++

      if (lockCount === 1) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
        originalOverflow = document.body.style.overflow
        originalPaddingRight = document.body.style.paddingRight

        document.body.style.overflow = 'hidden'
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`
        }
      }
    }

    if (!active && lockedByThis.current) {
      lockedByThis.current = false
      lockCount = Math.max(0, lockCount - 1)

      if (lockCount === 0) {
        document.body.style.overflow = originalOverflow
        document.body.style.paddingRight = originalPaddingRight
      }
    }

    return () => {
      if (lockedByThis.current) {
        lockedByThis.current = false
        lockCount = Math.max(0, lockCount - 1)

        if (lockCount === 0) {
          document.body.style.overflow = originalOverflow
          document.body.style.paddingRight = originalPaddingRight
        }
      }
    }
  }, [active])
}
